// extracted by mini-css-extract-plugin
export default {"ratingCell":"rating-form-cell_ratingCell__akULz","clearIcon":"rating-form-cell_clearIcon__z21LM"};